inputs-without-label-number-plus
  span.prefix(if="{opts.prefix}") {opts.prefix}
  input(class="form-control { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" type="number" value="{ opts.value }" onInput="{this.onInput}" onChange="{this.onChange}" style="width: {parseInt(opts.digits)+2}rem" min="{opts.min}")
  span.suffix(if="{opts.suffix}") {opts.suffix}
  span.btn.btn-up.icon-btn.btn-warning.btn-sm(onClick="{onClickPlus}")
    i.feather.icon-plus
  span.btn.btn-down.icon-btn.btn-info.btn-sm(onClick="{onClickMinus}")
    i.feather.icon-minus
  script(type="typescript").
    this.mixin('inputs.number');
  style(scoped).
    :scope {
      display: inline-block;
    }
    input.form-control {
      display: inline-block;
      width: auto;
    }
    .btn-up,
    .btn-down {
      margin-top: -3px;
      margin-left: 1px;
    }
    input {
      text-align: right;
    }
